import React from "react";
import "./landing.scss";
import Footer from "../../Components/Footer/footer";

const Landing = () => {
  return (
    <div className="landing-page">
      <div className="main-content">
        <div className="text-block row me-0 mr-0">
          <div className="d-flex pru-div col-sm-6">
            <h1 className="brand-name">PR</h1>
            <h1 className="dot-div">•</h1>
            <h1 className="brand-name ">UNE</h1>
          </div>
          <div className="tagline col-sm-6">
            <div className="tag-sub-div">
              <p className="tag-lines">ORCHESTRATE SYNERGIES</p>
              <p className="tag-lines">CHOREOGRAPH SUCCESSES</p>
            </div>
          </div>
        </div>
        <div className="email-hr">
          <hr className="email-side-lines" />
          <a
            href="mailto:info@pr-une.com"
            className="contact-email"
            rel="noopener noreferrer"
          >
            <span>info@pr-une.com</span>
          </a>
          <hr className="email-side-lines" />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Landing;
